export default __webpack_public_path__ + "static/media/line-awesome.58df7918.woff";